import { css } from '@linaria/core';

export const extendTeaserCompositionWithHeadlineOpinionTeaserLooks = css`
  .teaser-wrap .opinion-metadata {
    margin-top: 15px;
  }
`;
